import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LogService} from '../../services/log.service';
import {Log} from '../../model/log';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BranchesShowComponent} from '../../views/setting/branches/branches-show/branches-show.component';
import {TranslateService} from '@ngx-translate/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {validate} from 'codelyzer/walkerFactory/walkerFn';
import {User} from '../../model';
import {UserService} from '../../services/user.service';
import {Message} from 'primeng/api';
import {DepartmentsService} from '../../views/setting/departments/departments.service';
import {YearService} from "../../views/setting/years/year.service";

@Component({
    selector: 'app-departments-list',
    templateUrl: './departments-list.component.html',
    styleUrls: ['./departments-list.component.scss'],
    providers: []
})
export class DepartmentsListComponent implements OnInit {
    id: string;
    public user: User;
    userData: any;
    public logs: Log[];

    msgs: Message[] = [];
    @Input() branch_id;
    @Input() rowId;
    @Input() refRec: any;
    @Input() refShow;
    behalf:string;
    modalRef: NgbModalRef;
    form: FormGroup;
    sts:string;
    department_id:any;
    public newBranch:any;
    public departments:any[] = [];

    constructor(public activeModal: NgbActiveModal,
                public logService: LogService,
                private userService: UserService,
                private departmentsService:DepartmentsService,
                public translate: TranslateService,
                private YearService:YearService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            this.id = userdata.id;
            this.department_id = userdata.department_id;
        }

    }

    ngOnInit(){
        if(this.branch_id){
            this.userService.getUserBranDep(this.branch_id).subscribe(
                data => {
                    this.departments = data.departments;
                }
            );
        }
    }

    switchDepartment(id:any) {
        const user = JSON.parse(localStorage.getItem('currentUser'));
        user.department_id = id;
        let array:any;
        array = {'department_id': id};

        this.YearService.switchYear(array).subscribe(
            data=>{
                console.log('data ---> ', data);
            }
        );

        localStorage.setItem('currentUser', JSON.stringify(user));

        this.department_id = user.department_id;
        this.close();
    }

    close() {
        this.activeModal.dismiss('done');
    }

}



// WEBPACK FOOTER //
// ./src/app/components/departments-list/departments-list.component.ts